export const getYearsList = (count: number = 120)=>{
    const current = new Date();
    const list = new Array(count).fill(0).map((it, i)=>current.getUTCFullYear() - i);
    return list;
}

export const getMonthList = ()=>{
    return new Array(12).fill(0).map((it, i) => i);
}

export const getDatesList = (year: number, month: number)=>{
    const testMonth = new Date(0);
    testMonth.setUTCFullYear(year);
    testMonth.setUTCMonth(month);
    const savedMonth = testMonth.getUTCMonth();
    const result = new Array(28).fill(0).map((it, i) => i+1);
    for (let date = 29; date<=31; date++){
        testMonth.setUTCDate(date);
        if (testMonth.getUTCMonth() != savedMonth){
            break;
        } else {
            result.push(date);
        }
    }
    return result;
}